import { readLook } from "./look";

// small hardware feel on this device: a beep when a button is pressed and a ripple or sparkle where a finger lands.
// both read the device look on every press, so the setup switch works straight away

const PRESSABLE = "button, a[href], [role=button], .station, .key, .pill, .opt, .chip, summary, label.toggle, input[type=checkbox], input[type=range], select";
// drawing surfaces get every touch, a sparkle per stroke would be noise
const QUIET = 'canvas, #web-host, [class*="wb-"]';

let audio: AudioContext | null = null;

function beep(style: string, big: boolean): void {
  try {
    audio ??= new AudioContext();
    if (audio.state === "suspended") void audio.resume();
    const now = audio.currentTime;
    const gain = audio.createGain();
    const osc = audio.createOscillator();
    osc.connect(gain);
    gain.connect(audio.destination);
    if (style === "soft") {
      osc.type = "sine";
      osc.frequency.setValueAtTime(big ? 660 : 520, now);
      gain.gain.setValueAtTime(0.0001, now);
      gain.gain.exponentialRampToValueAtTime(0.05, now + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.09);
      osc.start(now);
      osc.stop(now + 0.1);
    } else if (style === "blip") {
      // two quick steps up, like a console menu
      osc.type = "square";
      osc.frequency.setValueAtTime(big ? 1046 : 880, now);
      osc.frequency.setValueAtTime(big ? 1568 : 1320, now + 0.04);
      gain.gain.setValueAtTime(0.025, now);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.1);
      osc.start(now);
      osc.stop(now + 0.11);
    } else {
      osc.type = "square";
      osc.frequency.setValueAtTime(big ? 220 : 160, now);
      osc.frequency.exponentialRampToValueAtTime(60, now + 0.03);
      gain.gain.setValueAtTime(0.06, now);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.035);
      osc.start(now);
      osc.stop(now + 0.04);
    }
  } catch {
    // no audio on this device, nothing to do
  }
}

function drop(className: string, x: number, y: number, vars?: Record<string, string>): void {
  const bit = document.createElement("i");
  bit.className = className;
  bit.style.left = `${x}px`;
  bit.style.top = `${y}px`;
  for (const [name, value] of Object.entries(vars ?? {})) bit.style.setProperty(name, value);
  bit.addEventListener("animationend", () => bit.remove(), { once: true });
  document.body.append(bit);
}

export function setupFx(): void {
  document.addEventListener("pointerdown", (event) => {
    const look = readLook();
    if (look.sfx === "off" && look.tap === "off") return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target || target.closest(QUIET)) return;
    if (look.sfx !== "off" && target.closest(PRESSABLE)) beep(look.sfx, Boolean(target.closest(".station")));
    if (look.tap === "ripple") drop("fx-ripple", event.clientX, event.clientY);
    else if (look.tap === "spark") {
      for (let i = 0; i < 6; i++) {
        const angle = (Math.PI * 2 * i) / 6 + Math.random() * 0.6;
        const reach = 26 + Math.random() * 26;
        drop("fx-spark", event.clientX, event.clientY, { "--dx": `${Math.cos(angle) * reach}px`, "--dy": `${Math.sin(angle) * reach}px` });
      }
    }
  }, { capture: true, passive: true });
}
